// extracted by mini-css-extract-plugin
export default {"container":"map_container__giXeS","close":"map_close__Dn1Rx"};